var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalFlowTank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_91887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 536.602H853.393V658.779L780.204 610.404L673.861 655.677L566.264 610.403L473.058 696.61L372.342 725.14L327.928 688.548L292.897 635.831L259.742 667.462L185.926 606.062L134.63 613.505L77.08 564.509L2.63965 545.904L3.264 536.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 536.602V537.203H852.787V657.655L780.267 609.722L673.859 655.023L566.139 609.697L472.75 696.071L372.483 724.474L328.385 688.142L293.001 634.896L259.714 666.653L186.108 605.428L134.816 612.869L77.3663 563.961L3.27796 545.443L3.86903 536.642L3.26384 536.602V537.203V536.602L2.65865 536.562L2 546.364L76.7934 565.058L134.445 614.14L185.745 606.697L259.769 668.27L292.792 636.767L327.47 688.953L372.201 725.805L473.364 697.148L566.39 611.109L673.861 656.331L780.141 611.085L854 659.903V536H2.69597L2.65865 536.562L3.26384 536.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 536.602V537.203H852.787V657.655L780.267 609.722L673.859 655.023L566.139 609.697L472.75 696.071L372.483 724.474L328.385 688.142L293.001 634.896L259.714 666.653L186.108 605.428L134.816 612.869L77.3663 563.961L3.27796 545.443L3.86903 536.642L3.26384 536.602ZM3.26384 536.602V537.203V536.602ZM3.26384 536.602L2.65865 536.562L2 546.364L76.7934 565.058L134.445 614.14L185.745 606.697L259.769 668.27L292.792 636.767L327.47 688.953L372.201 725.805L473.364 697.148L566.39 611.109L673.861 656.331L780.141 611.085L854 659.903V536H2.69597L2.65865 536.562L3.26384 536.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9004 535.5L155.9 534.5C155.567 519.833 155.234 505.167 154.9 490.5L162.9 464.5L153.9 449.5C159.69 442.68 166.9 431.95 164.9 420.5C162.53 406.78 149.05 403.89 148.9 392.5C148.75 380.55 163.53 379.09 172.9 359.5C180.95 342.67 173.25 337.04 180.9 326.5C193.79 308.73 220.08 318.64 226.9 303.5C231.71 292.84 221.9 280.67 230.9 266.5C232.045 264.691 233.387 263.014 234.9 261.5H554.9C558.57 268.83 555.23 274.17 558.9 281.5C564.9 284.15 571.65 283.31 573.9 285.5C579.13 290.59 573.9 297.22 581.9 313.5C584.55 318.88 598.7 313.14 599.9 315.5C600.23 287.17 599.57 273.83 599.9 245.5C504.9 212.5 404.8 194.59 307.9 194.5C219.46 194.42 131.9 208.5 43.9004 245.5V535.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.69 245H44.4004V535.22H599.69V245Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4 225H201V531H216.4V225Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4 172H194V179H223.4V172Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23 262H196.83V273.57H220.23V262Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23 286H196.83V302H220.23V286Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.73 274H199.33V286H217.73V274Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4 531H197V535.57H220.4V531Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4 224H199V225.24H217.4V224Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.19 146H199.61C197.838 146 196.4 147.437 196.4 149.21V172.79C196.4 174.563 197.838 176 199.61 176H217.19C218.963 176 220.4 174.563 220.4 172.79V149.21C220.4 147.437 218.963 146 217.19 146Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.4004 535L156.4 534C156.067 519.333 155.734 504.667 155.4 490L163.4 464L154.4 449C160.19 442.18 167.4 431.45 165.4 420C163.03 406.28 149.55 403.39 149.4 392C149.25 380.05 164.03 378.59 173.4 359C181.45 342.17 173.75 336.54 181.4 326C194.29 308.23 220.58 318.14 227.4 303C232.21 292.34 222.4 280.17 231.4 266C232.545 264.191 233.887 262.514 235.4 261H555.4C559.07 268.33 555.73 273.67 559.4 281C565.4 283.65 572.15 282.81 574.4 285C579.63 290.09 574.4 296.72 582.4 313C585.05 318.38 599.2 312.64 600.4 315C600.73 286.67 600.07 273.33 600.4 245C505.4 212 405.3 194.09 308.4 194C219.96 193.92 132.4 208 44.4004 245V535Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4 209H201V224H216.4V209Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4 179.52H36V190H223.4V179.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4 190H194V193H223.4V190Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4 197H197V208.57H220.4V197Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4 142H204V145.57H206.4V142Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4 194H201V195.24H215.4V194Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.4 172H178.4V194H185.4V172Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.429 142H210.029V145.57H212.429V142Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_91887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalFlowTank);
export default __webpack_public_path__ + "static/media/total-flow-tank.e67fce52694333111cc36b3338a5db87.svg";
export { ForwardRef as ReactComponent };